var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScaleBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0003 5.25C18.7778 5.25 16.8003 6.65 16.0653 8.75H5.25031V12.25H8.66281L3.50031 24.5C2.67781 28 5.25031 29.75 9.62531 29.75C14.0003 29.75 16.7303 28 15.7503 24.5L10.5878 12.25H16.0478C16.6253 13.7375 17.7628 14.875 19.2503 15.4525V35H3.50031V38.5H38.5003V35H22.7503V15.435C24.2378 14.875 25.3753 13.7375 25.9353 12.25H31.4128L26.2503 24.5C25.4278 28 28.0003 29.75 32.3753 29.75C36.7503 29.75 39.4803 28 38.5003 24.5L33.3378 12.25H36.7503V8.75H25.9528C25.2003 6.65 23.2228 5.25 21.0003 5.25ZM21.0003 8.75C21.4644 8.75 21.9096 8.93437 22.2377 9.26256C22.5659 9.59075 22.7503 10.0359 22.7503 10.5C22.7503 10.9641 22.5659 11.4092 22.2377 11.7374C21.9096 12.0656 21.4644 12.25 21.0003 12.25C20.5362 12.25 20.0911 12.0656 19.7629 11.7374C19.4347 11.4092 19.2503 10.9641 19.2503 10.5C19.2503 10.0359 19.4347 9.59075 19.7629 9.26256C20.0911 8.93437 20.5362 8.75 21.0003 8.75ZM9.62531 17.9375L12.2503 24.5H7.00031L9.62531 17.9375ZM32.3753 17.9375L35.0003 24.5H29.7503L32.3753 17.9375Z",
    fill: "#757EF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleBalance);
export default __webpack_public_path__ + "static/media/scale-balance.883ca4597d13b4c379f2f9fd9f514fed.svg";
export { ForwardRef as ReactComponent };